/* Built In Imports */
/* External Imports */
import axios from 'axios';

/* Internal Imports */
/* Components */
import config from '@config';

export const getTicketList = async id => {
  try {
    const response = await axios.get(
      `${config.EOE_EVENT}/event/${id}/tickets-list/`
    );
    //console.log(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};
